import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  async copy() {
    const text = this.textValue || this.element.dataset.clipboardText
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      const original = this.element.dataset.originalLabel || this.element.textContent.trim()
      this.element.dataset.originalLabel = original
      this.element.textContent = t('javascript.controllers.clipboard_controller.copied')
      window.setTimeout(() => {
        this.element.textContent = this.element.dataset.originalLabel
      }, 1500)
    } catch (_error) {
      // Clipboard may be unavailable in non-secure contexts; fail silently.
    }
  }
}
